import React from "react";

export default class AppErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Mini App failed to render", error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <main
        role="alert"
        style={{
          minHeight: "100vh",
          boxSizing: "border-box",
          display: "grid",
          placeItems: "center",
          padding: 24,
          background: "#0b0e14",
          color: "#fff",
          fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, sans-serif",
          textAlign: "center",
        }}
      >
        <section style={{ maxWidth: 360 }}>
          <h1 style={{ fontSize: 22, marginBottom: 10 }}>Не удалось открыть приложение</h1>
          <p style={{ color: "#aab3c2", lineHeight: 1.5, marginBottom: 20 }}>
            Произошла ошибка при запуске интерфейса. Попробуйте обновить Mini App.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{ border: 0, borderRadius: 14, padding: "12px 20px", background: "#1685ff", color: "#fff", fontWeight: 700 }}
          >
            Перезагрузить
          </button>
        </section>
      </main>
    );
  }
}
